import React, { useEffect, useState } from "react";
import { ZonesTable } from "./Table_Zoneview";


export const ZonesView = () => {

  return <ZonesTable />;
};
